import { CtaButton } from '@/components/astro/cta-button/cta-button';
import '@/styles/astro/new-design.css';

export function BrowserExtensionHero() {
  return (
    <section
      aria-labelledby='hero-heading'
      className='relative py-16 lg:py-24'
      itemScope
      itemType='https://schema.org/SoftwareApplication'
    >
      <div className='container mx-auto px-4 lg:px-8'>
        <div className='mx-auto max-w-4xl text-center'>
          <header className='mb-8'>
            <h1
              className='mb-6 text-3xl font-bold text-gray-900 sm:text-4xl lg:text-6xl'
              id='hero-heading'
              itemProp='name'
            >
              Instantly Convert{' '}
              <span className='text-blue-600'>
                Webpages, Documents, & PDFs{' '}
              </span>
              into Audio with Our Browser Extension
            </h1>
            <p
              className='mx-auto mb-8 max-w-3xl text-base text-gray-600 sm:text-lg lg:text-xl'
              itemProp='description'
            >
              Experience effortless listening with our intuitive browser
              extension. Highlight text, make notes, and enjoy crystal-clear
              audio powered by natural-sounding AI voices.
            </p>
          </header>
          <div className='mb-12 flex flex-col items-center justify-center gap-4 sm:flex-row'>
            <CtaButton
              className='rounded-full bg-royal-50 px-8 py-7 text-xl font-light text-white hover:bg-black/80 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-hidden'
              href='https://chromewebstore.google.com/detail/listeningcom/amjjglmomeodglgclcnjdjbhhcfnbnpd'
              label='Add to Browser Now'
              variant='gradient'
            />
          </div>

          <div
            aria-label='Key features'
            className='mb-8 flex flex-wrap justify-center gap-3'
            itemScope
            itemType='https://schema.org/ItemList'
          >
            <span
              className='rounded-full bg-blue-50 px-4 py-2 text-sm font-medium text-blue-700'
              itemProp='itemListElement'
            >
              <meta content='1' itemProp='position' />
              <span itemProp='item'> ✨ Natural AI Voices </span>
            </span>
            <span
              className='rounded-full bg-green-50 px-4 py-2 text-sm font-medium text-green-700'
              itemProp='itemListElement'
            >
              <meta content='2' itemProp='position' />
              <span itemProp='item'> 📝 Highlight & Listen </span>
            </span>
            <span
              className='rounded-full bg-purple-50 px-4 py-2 text-sm font-medium text-purple-700'
              itemProp='itemListElement'
            >
              <meta content='3' itemProp='position' />
              <span itemProp='item'> 🎧 Instant Playback </span>
            </span>
            <span
              className='rounded-full bg-orange-50 px-4 py-2 text-sm font-medium text-orange-700'
              itemProp='itemListElement'
            >
              <meta content='4' itemProp='position' />
              <span itemProp='item'> 📱 Multi-browser Support </span>
            </span>
          </div>

          {/* <!-- <div className="relative max-w-4xl mx-auto">
        <figure
          className="aspect-video bg-gradient-to-br from-blue-50 to-purple-50 rounded-2xl border-2 border-gray-200 flex items-center justify-center shadow-xl"
          itemScope
          itemType="https://schema.org/VideoObject"
          aria-label="Browser extension demonstration video"
        >
          <div className="text-center">
            <div
              className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4"
              aria-hidden="true"
            >
              <svg
                className="w-8 h-8 text-white"
                fill="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path d="M8 5v14l11-7z"></path>
              </svg>
            </div>
            <p className="text-gray-600 font-medium" itemProp="name">
              Watch How It Works
            </p>
          </div>
        </figure>
      </div> --> */}
        </div>
      </div>
    </section>
  );
}
